import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PhoneCall, DollarSign } from "lucide-react";

export function SundayBonusDialog({ open, onClose, onDecide }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        className="max-w-sm p-0 gap-0 rounded-3xl overflow-hidden bg-black/85 backdrop-blur-2xl border border-white/15 text-white"
        data-testid="sunday-bonus-dialog"
      >
        <DialogHeader className="p-6 pb-2 text-left">
          <div className="w-12 h-12 rounded-2xl glass-pill flex items-center justify-center mb-3">
            <PhoneCall className="w-6 h-6 text-emerald-300" strokeWidth={2.2} />
          </div>
          <DialogTitle className="font-heading text-xl font-bold text-white">
            Sunday check-in
          </DialogTitle>
          <DialogDescription className="text-sm text-white/60 mt-1">
            Did you hit 200 calls today? Sunday-only <span className="text-emerald-300 font-semibold">+$100 bonus</span> if yes.
          </DialogDescription>
        </DialogHeader>
        <div className="p-6 pt-4 flex gap-2">
          <button
            onClick={() => onDecide(false)}
            className="flex-1 py-3 rounded-full glass-pill text-sm font-semibold text-white active:opacity-70"
            data-testid="sunday-bonus-no"
          >
            No, skip bonus
          </button>
          <button
            onClick={() => onDecide(true)}
            className="flex-1 py-3 rounded-full bg-white text-black font-semibold active:opacity-80 inline-flex items-center justify-center gap-1.5"
            data-testid="sunday-bonus-yes"
          >
            <DollarSign className="w-4 h-4" /> Yes, +$100
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
